import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly tokenKey = 'auth_token';
  // fallback for non-browser environments (SSR, tests) or when localStorage access is blocked
  private inMemoryToken: string | null = null;

  private storageAvailable(): boolean {
    try {
      return typeof window !== 'undefined' && !!window.localStorage;
    } catch {
      return false;
    }
  }

  setToken(token: string | null): void {
    if (this.storageAvailable()) {
      try {
        if (token) {
          window.localStorage.setItem(this.tokenKey, token);
        } else {
          window.localStorage.removeItem(this.tokenKey);
        }
        // keep in-memory copy in case localStorage becomes inaccessible later
        this.inMemoryToken = token;
      } catch {
        // localStorage might throw (privacy mode) — fall back to memory
        this.inMemoryToken = token;
      }
    } else {
      this.inMemoryToken = token;
    }
  }

  getToken(): string | null {
    if (this.storageAvailable()) {
      try {
        const v = window.localStorage.getItem(this.tokenKey);
        if (v !== null) return v;
        return this.inMemoryToken;
      } catch {
        return this.inMemoryToken;
      }
    }
    return this.inMemoryToken;
  }

  clearToken(): void {
    this.setToken(null);
  }

  isAuthenticated(): boolean {
    const t = this.getToken();
    return !!t;
  }
}
